/**
 * Retorna o valor atual sem modificações.
 *
 * @param {*} value - Valor atual.
 * @returns {*} - Mesmo valor passado como argumento.
 */
export const always = (_token, value) => value;
